// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"PhotoGallery-module--thumbnail--1eeIk","activeThumbnail":"PhotoGallery-module--activeThumbnail--2OdyA","imageWrapper":"PhotoGallery-module--imageWrapper--1-IX4"};